export function recordContentType (fileType = 'webm') {
  if (fileType === 'mp4') {
    return 'video/mp4'
  }

  return 'video/webm'
}

export function recordMimeType (fileType = 'webm') {
  if (fileType === 'mp4') {
    return 'video/mp4;codecs=avc1'
  }

  return 'video/webm;codecs=vp8,opus'
}
